module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show && !_vm.opened && !_vm.showCta) ? _c('div', {
    staticClass: "imbee-bubble-close-cross",
    style: ({
      color: _vm.color,
      backgroundColor: _vm.backgroundColor,
      fontWeight: _vm.fontWeight,
      height: _vm.size,
      width: _vm.size,
      top: _vm.top,
      right: _vm.right,
    }),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.crossClicked.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "remove-bot",
    style: ({
      fontSize: _vm.fontSize
    }),
    attrs: {
      "id": "remove-bot"
    }
  }, [_c('svg', {
    attrs: {
      "data-v-bd4127ec": "",
      "stroke": "currentColor",
      "fill": "currentColor",
      "stroke-width": "0",
      "viewBox": "0 0 32 32",
      "height": "1em",
      "width": "1em",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "data-v-bd4127ec": "",
      "d": "M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23da2404"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CloseCross.vue
// module id = 207
// module chunks = 0 1